const language = {
    ENGLISH: 'English',
    BULGARIAN: 'Bulgarian',
    ROMANIAN: 'Romanian',
}

const country = {
    BULGARIA: 'Bulgaria',
    ROMANIA: 'Romania',
}

const navigation = {
    NAVIGATION_HOME: 'Home',
    NAVIGATION_TEAM: 'Team',
    NAVIGATION_STATISTICS: 'Statistics',
    NAVIGATION_SETTINGS: 'Settings',
    NAVIGATION_QR: 'QR-code',
    NAVIGATION_HELP: 'Help',
}

const header = {
    HEADER_LOGOUT: 'Logout',
}

const months = {
    JANUARY: 'January',
    FEBRUARY: 'February',
    MARCH: 'March',
    APRIL: 'April',
    MAY: 'May',
    JUNE: 'June',
    JULY: 'July',
    AUGUST: 'August',
    SEPTEMBER: 'September',
    OCTOBER: 'October',
    NOVEMBER: 'November',
    DECEMBER: 'December',
}

const shortMonths = {
    JAN: 'Jan',
    FEB: 'Feb',
    MAR: 'Mar',
    APR: 'Apr',
    MAY: 'May',
    JUN: 'Jun',
    JUL: 'Jul',
    AUG: 'Aug',
    SEP: 'Sep',
    OCT: 'Oct',
    NOV: 'Nov',
    DEC: 'Dec',
}

const auth = {
    AUTH_CASHLESS_TIPS: 'CASHLESS TIPS',
    AUTH_UP_TO_40: 'Up to 40% more tips every day',
    AUTH_SIGNIN_OPTION: 'SIGN IN',
    AUTH_SIGNUP_OPTION: 'SIGN UP',
    AUTH_SIGNIN_TITLE: 'Sign in',
    AUTH_SIGNUP_TITLE: 'Sign up',
    AUTH_NAME: 'Name',
    AUTH_NAME_PLACEHOLDER: 'Enter your name',
    AUTH_ORGANIZATION: 'Organization',
    AUTH_ORGANIZATION_PLACEHOLDER: 'Enter organization name',
    AUTH_COUNTRY: 'Country',
    AUTH_COUNTRY_PLACEHOLDER: 'Select a country from the list',
    AUTH_COUNTRY_PLACEHOLDER_SHORT: 'Select a country',
    AUTH_PHONE: 'Phone',
    AUTH_PHONE_PLACEHOLDER: 'Enter your phone',
    AUTH_EMAIL: 'E-mail',
    AUTH_EMAIL_PLACEHOLDER: 'Enter your e-mail',
    AUTH_PASSWORD: 'Password',
    AUTH_SIGNUP_PASSWORD_PLACEHOLDER: 'Come up with a password',
    AUTH_SIGNIN_PASSWORD_PLACEHOLDER: 'Enter your password',
    AUTH_FORGOT_PASSWORD: 'Forgot password?',
    AUTH_SOCIAL: 'Or use social media to sign in',
    AUTH_SELECT_LANGUAGE: 'Select language',
    AUTH_STRIPE_TOS:
        'We use Stripe to make sure you get paid on time and keep your personal and bank details secure.',
    AUTH_CANCEL_BUTTON: 'CANCEL',
    AUTH_SIGNIN_BUTTON: 'SIGN IN',
    AUTH_SIGNUP_BUTTON: 'SIGN UP',
}

const onboarding = {
    ONBOARDING_STEP: 'Step',
    ONBOARDING_STEP_REGISTRATION: 'Registration',
    ONBOARDING_STEP_EMAIL: 'Email confirmation',
    ONBOARDING_STEP_STRIPE: 'Stripe',

    ONBOARDING_EMAIL_DESCRIPTION:
        'We have sent you an email with confirmation code to',
    ONBOARDING_ENTER_CODE: 'ENTER THE CODE FROM THE EMAIL',
    ONBOARDING_SEND_CODE_AGAIN: 'Send the code again',
    ONBOARDING_INCORRECT_CODE: 'INCORRECT CODE',
    ONBOARDING_BACK: 'BACK',

    ONBOARDING_STRIPE_DESCRIPTION:
        'TO CONNECT THE PAYMENT SYSTEM, YOU NEED TO CREATE AN ACCOUNT IN STRIPE\r\n(Payment Processing Platform)',
    ONBOARDING_GO_TO_STRIPE: 'GO TO STRIPE',
    ONBOARDING_STRIPE_SUCCESS: 'ACCOUNT SUCCESSFULLY CREATED',
    ONBOARDING_OK: 'OK',
}

const home = {
    HOME_CURRENT_MONTH: 'Tips for the current month',
    HOME_YEAR_TIPS: 'Tips for the year',
    HOME_NPS: 'NPS',
    HOME_TOP_STAFF: 'Top staff',
    HOME_LAST_MONTH: 'last month',
    HOME_CASH_TIP: 'Cash tip',
    HOME_CASH_TIP_DESCRIPTION: 'Add cash tips to include in statistics',
    HOME_ADD_TIP_BUTTON: 'ADD TIP',
}

const qr = {
    QR_TITLE: 'QR-code',
    QR_DOWNLOAD: 'DOWNLOAD',
    QR_POSM: 'POSM',
    QR_STICKER: 'Sticker',
    QR_CARD: 'Card',
    QR_TABLETOP: 'Tabletop sign',
    QR_STICKER_SIZE: 'Recommended size\n for printing is 80x80mm',
    QR_CARD_SIZE: 'Recommended size\n for printing is 80x80mm',
    QR_TABLETOP_SIZE: 'Recommended size\n for printing is 148x210mm',
    QR_TAB_ORGANIZATION: 'Organization QR-code',
    QR_TAB_EMPLOYEES: 'Employee QR-codes',
    QR_REMOVE_EMPLOYEE: 'Remove employee?',
    QR_BUTTON_REMOVE: 'REMOVE',
    QR_BUTTON_CANCEL: 'CANCEL',

    QR_SORT_PLACEHOLDER: 'Sort by',
    QR_SORT_BY_NAME: 'Name',
    QR_SORT_RATING: 'Rating',
    QR_SORT_TIPS_AMOUNT: 'Tips amount',
    QR_SORT_EXPERIENCE: 'Work experience',

    QR_EMPLOYEE_MODAL_ROLE_PLACEHOLDER: 'Select from the list',
    QR_EMPLOYEE_MODAL_BIRTH_PLACEHOLDER_DAY: 'Day',
    QR_EMPLOYEE_MODAL_BIRTH_PLACEHOLDER_MONTH: 'Month',
    QR_EMPLOYEE_MODAL_BIRTH_PLACEHOLDER_YEAR: 'Year',
    QR_EMPLOYEE_MODAL_REMOVE_EMPLOYEE: 'Remove employee',



    QR_EMPLOYEE_PHONE: 'Phone',
    QR_EMPLOYEE_EMAIL: 'E-mail',

    QR_EMPLOYEE_MODAL_FULL_NAME: 'Full name',
    QR_EMPLOYEE_MODAL_FULL_NAME_PLACEHOLDER: 'Enter full name',
    QR_EMPLOYEE_MODAL_DATE_OF_BIRTH: 'Date of birth',
    QR_EMPLOYEE_MODAL_DATE_OF_BIRTH_PLACEHOLDER: 'Enter birthday',
    QR_EMPLOYEE_MODAL_PHONE: 'Phone',
    QR_EMPLOYEE_MODAL_PHONE_PLACEHOLDER: 'Enter phone',
    QR_EMPLOYEE_MODAL_EMAIL: 'E-mail',
    QR_EMPLOYEE_MODAL_EMAIL_PLACEHOLDER: 'Enter e-mail',
    QR_EMPLOYEE_MODAL_POSITION: 'Position',
    QR_EMPLOYEE_MODAL_POSITION_PLACEHOLDER: 'Select from the list',
    QR_EMPLOYEE_MODAL_ADD_NEW: 'Add new',
    QR_EMPLOYEE_MODAL_CANCEL_BUTTON: 'CANCEL',
    QR_EMPLOYEE_MODAL_SAVE_BUTTON: 'SAVE',
}

const errors = {
    ERROR_DEFAULT: 'Something went wrong',
    ERROR_CODE_RESEND_WRONG_EMAIL: 'Wrong email',
    ERROR_CODE_RESEND_TOO_EARLY: 'Code resend is too early',
    ERROR_SESSION_EXPIRED: 'Your session has expired',
    ERROR_EMAIL_CODE_NOT_VALID: 'Code is not valid',
    ERROR_EMAIL_IS_ALREADY_USED: 'Email is already used',
    ERROR_EMAIL_WRONG_CREDENTIALS: 'Wrong email or password',
}

const statistics = {
    STATISTICS_CURRENT_MONTH: 'Total tips and rating',
    STATISTICS_CURRENT_MONTH_RATING: 'Rating',
    STATISTICS_YEAR_TIPS: 'Tips for the year',
    STATISTICS_EMPLOYEES_TABLE_TITLE: 'Total tips by employee',

    STATISTICS_EMPLOYEES_TABLE_NO: 'No',
    STATISTICS_EMPLOYEES_TABLE_AVATAR: '',
    STATISTICS_EMPLOYEES_TABLE_NAME: 'Name',
    STATISTICS_EMPLOYEES_TABLE_ROLE: 'Role',
    STATISTICS_EMPLOYEES_TABLE_RATING: 'Rating',
    STATISTICS_EMPLOYEES_TABLE_TIPS: 'Tips',

    STATISTICS_FEES_DISCLAIMER: "Please be informed that provided numbers don't include fees and taxes.",
}

const validationErrors = {
    VALIDATION_TOO_SHORT: 'Too short',
    VALIDATION_TOO_LONG: 'Too long',
    VALIDATION_INVALID_EMAIL: 'Invalid email',
    VALIDATION_NO_SPACE: 'Space character is not allowed',
    VALIDATION_PHONE_FORMAT: 'Wrong phone format',
}

const en = {
    ...errors,
    ...validationErrors,
    ...language,
    ...country,
    ...months,
    ...shortMonths,
    ...header,
    ...onboarding,
    ...navigation,
    ...auth,
    ...home,
    ...statistics,
    ...qr,
} as const

export default en
